import React from 'react';
import { observer } from 'mobx-react';
import { CellProps } from '../../stores/card/ModeExcel';
import CardStore from '../../stores/card';
import { WeaLocaleProvider } from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;

interface ExcelTableCellDivProps {
    cell: CellProps;
    card: CardStore;
}

@observer
export default class CellLikes extends React.Component<ExcelTableCellDivProps, any> {
    likeOrDislike1 = () => {
        const { card } = this.props
        if (card.likestatus == '1') {
            card.likeOrdislike('0');
        } else {
            card.likeOrdislike('1');
        }
    }

    likeOrDislike2 = () => {
        const { card } = this.props;
        if (card.likestatus == '2') {
            card.likeOrdislike('0');
        } else {
            card.likeOrdislike('2');
        }
    }


    render() {
        const { cell, card } = this.props;
        const { isallowlike, likeshowname, isallowdislike, dislikeshowname, likecount, dislikecount, likestatus } = card;
        let liketitle = likeshowname;
        let disliketitle = dislikeshowname;
        let likeicon = '';
        let dislikeicon = '';
        if (likestatus == '1') {
            if (likeshowname == '') {
                liketitle = getLabel('32944', '取消赞');
            } else {
                liketitle = getLabel('31129', '取消') + likeshowname;
            }
            if (dislikeshowname == '') {
                disliketitle = getLabel('515888', '踩');
            }
            likeicon = 'icon-coms02-like'
            dislikeicon = 'icon-coms02-Negative-comment-o'
        } else if (likestatus == '2') {
            if (likeshowname == '') {
                liketitle = getLabel('32942', '赞');
            }
            if (dislikeshowname == '') {
                disliketitle = getLabel('515889', '取消踩');
            } else {
                disliketitle = getLabel('31129', '取消') + dislikeshowname;
            }
            likeicon = 'icon-coms02-like-o'
            dislikeicon = 'icon-coms02-Negative-comment'
        } else {
            if (likeshowname == '') {
                liketitle = getLabel('32942', '赞');
            }
            if (dislikeshowname == '') {
                disliketitle = getLabel('515888', '踩');
            }
            likeicon = 'icon-coms02-like-o'
            dislikeicon = 'icon-coms02-Negative-comment-o'
        }

        if (cell && cell.evalue == "#likes#" && isallowlike == "1") {
            return <div style={{ 'cursor': 'pointer' }}>
                <i title={liketitle} className={likeicon} onClick={this.likeOrDislike1} /><span>{' ' + likeshowname + ' (' + likecount + ')'}</span>
            </div>
        }
        if (cell && cell.evalue == "#dislikes#" && isallowdislike == "1") {
            return <div style={{ 'cursor': 'pointer' }}>
                <i title={disliketitle} className={dislikeicon} onClick={this.likeOrDislike2} /><span>{' ' + dislikeshowname + ' (' + dislikecount + ')'}</span>
            </div>
        }
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/CellLikes.tsx